<div class="row" *ngFor="let param of barChartParameters let i = index" style="width: 70%;">
    <div class="inner vibrationInner" >
        <ng-container *ngIf="barchartloading; else barchartTemplate">
            <div class="spinner-container">
                <div class="spinner-border text-primary" role="status"></div>

            </div>

        </ng-container>
        <ng-template #barchartTemplate>
            <div class="">
                <div class="heading">
                    <p>{{ param.name }}</p>
                </div>
                <div style="position: relative; position: relative; text-align: center; justify-content: center; display: flex;"
                >
                    <!-- <mat-slide-toggle [checked]="param.value === '1' ? true : false" [ngClass]="{ 'disabled-toggle': true }" style="transform: rotate(90deg);"></mat-slide-toggle> -->
                    <div class="circle_toggle" [matTooltip]="param.value == 1?'ON':'OFF'" [ngStyle]="param.value == 1 ? {'background-color':'#83f10d'} : {'background-color':'#ff2a1b'}"></div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
